import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const GoogleMeet = (props: TIconProps): ReactElement => (
  <svg
    width="25"
    height="21"
    viewBox="0 0 25 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#googlemeet_clip0_439_72807)">
      <path
        d="M14.1232 10.7286L16.5569 13.5105L19.8295 15.6018L20.4002 10.7457L19.8295 5.99805L16.4942 7.83549L14.1232 10.7286Z"
        fill="hsl(from hsl(142 100% 26%) h s 37%)"
      />
      <path
        d="M0 15.151V19.2881C0 20.2339 0.766077 21 1.7119 21H5.84901L6.70496 17.8729L5.84901 15.151L3.0101 14.295L0 15.151Z"
        fill="hsl(from hsl(142 100% 26%) h s 38%)"
      />
      <path
        d="M5.84901 0.457153L0 6.30616L3.0101 7.16211L5.84901 6.30616L6.6907 3.62132L5.84901 0.457153Z"
        fill="hsl(from hsl(142 100% 26%) h s 50%)"
      />
      <path
        d="M5.84901 6.30615H0V15.151H5.84901V6.30615Z"
        fill="hsl(from hsl(142 100% 26%) h s 51%)"
      />
      <path
        d="M23.5672 2.9337L19.8296 5.99801V15.6018L23.5843 18.6804C24.1464 19.1198 24.9681 18.7189 24.9681 18.0042V3.59564C24.9681 2.87236 24.1279 2.47577 23.5672 2.9337ZM14.1232 10.7286V15.151H5.849V21H18.1176C19.0635 21 19.8296 20.2339 19.8296 19.2881V15.6018L14.1232 10.7286Z"
        fill="hsl(from hsl(142 100% 26%) h s 48%)"
      />
      <path
        d="M18.1176 0.457153H5.849V6.30616H14.1232V10.7286L19.8296 6.00087V2.16906C19.8296 1.22323 19.0635 0.457153 18.1176 0.457153Z"
        fill="hsl(from hsl(142 100% 26%) h s 76%)"
      />
    </g>
    <defs>
      <clipPath id="googlemeet_clip0_439_72807">
        <rect
          width="24.9653"
          height="20.5429"
          fill="white"
          transform="translate(0 0.457153)"
        />
      </clipPath>
    </defs>
  </svg>
);
